<template>
  <!-- 这里是关于中优 -->
  <div>

    <div class="banner" v-if="banner">
      <img :src="banner" alt="" style="width: 100%;">
    </div>
    <!-- 导航 -->
    <div class="tabs">
      <el-tabs v-model="activeName" @tab-click="handleClick" stretch>
        <el-tab-pane :label="item.t_name" :name="item.t_name" v-for="item in tabsList" :key="item.id">
          <!-- 中优简介 -->
          <div class="c_introduction" v-if="item.t_name === '中优简介'">
            <div class="c_pic" style="width: 1890px;position: absolute;top: -113px; left: 50% !important;transform: translate(-50%);">
              <img style="object-fit: contain;" :src="tabData.show_img" alt="">
            </div>
            <div class="c_box left"
              style="width: 1323px;position: absolute;top: 115px; left: 50% !important;transform: translate(-50%);">
              <div class="c_word" style="width: 678px;margin: 0;">
                <div class="c_title">
                  <span class="c_tl">{{ tabData.title }}</span>
                  <span class="e_tl">{{ tabData.t_desc }}</span>
                </div>
                <div class="c_text" v-html="tabData.content" style="color: #333;width: 678px;">
                </div>
                <div class="shuzi" style="width: 480px;">
                  <div class="digit" v-if="tabData.reserve_1">
                    <div>
                      <div class="top">
                        <div class="big_digit" style="font-size: 42px;">
                          {{ tabData.reserve_1 }}
                        </div>
                        <div class="right">
                          <div class="top1">+</div>
                          <div class="bottom1" style="padding-left: 2px;">
                            年
                          </div>
                        </div>
                      </div>
                      <div class="bottom">
                        {{ tabData.reserve_desc_1 }}
                      </div>
                    </div>
                  </div>
                  <div class="digit" v-if="tabData.reserve_2">
                    <div>
                      <div class="top">
                        <div class="big_digit" style="margin-left: 6px;font-size: 42px;">
                          {{ tabData.reserve_2 }}
                        </div>
                        <div class="right" style="margin-left: -15px;">
                          <div class="top1"></div>
                          <div class="bottom1">
                            所
                          </div>
                        </div>
                      </div>
                      <div class="bottom">
                        {{ tabData.reserve_desc_2 }}
                      </div>
                    </div>
                  </div>
                  <div class="digit" v-if="tabData.reserve_3">
                    <div>
                      <div class="top">
                        <div class="big_digit" style="font-size: 42px;">
                          {{ tabData.reserve_3 }}
                        </div>
                        <div class="right">
                          <div class="top1">+</div>
                          <div class="bottom1" style="margin-left: 3px;">
                            万
                          </div>
                        </div>
                      </div>
                      <div class="bottom">
                        {{ tabData.reserve_desc_3 }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 组织架构 -->
          <div v-if="item.t_name === '组织架构'">
            <div style="width: 100%;text-align: center;">
              <div class="c_title">
                <div class="c_tl">{{ tabData.title }}</div>
                <div class="e_tl">{{ tabData.t_desc }}</div>
                <div class="top" style="width: 100%;height: 100%;" v-html="tabData.content"></div>
              </div>
            </div>
          </div>
          <!-- 发展历程 -->
          <div v-if="item.t_name === '发展历程'">
            <div class="fzlc" style="text-align: center;">
              <div class="c_title">
                <div class="c_tl"> {{ item.t_name }} </div>
                <div class="e_tl">{{ item.t_name_deputy }}</div>
              </div>
              <div class="time_line">
                <div class="time_boxs" :style="{ width: width }">
                  <div class="time_box" :class="{ active: index % 2 == 1 }" v-for="(i, index) in tabData" :key="i?.id">
                    <div class="tm">{{ i?.t_desc }}</div>
                    <div class="cot" v-html="i?.content"></div>
                  </div>
                </div>
              </div>
              <div class="scroll_div">
                <el-slider style="width: 1920px;" v-model="sliderValue" @input="changeHandler" :show-tooltip="false" />
              </div>
            </div>
          </div>
          <!-- 研发实力 -->
          <div v-if="item.t_name === '研发实力'">
            <div class="yfsl">
              <div class="tt">
                <div class="cn">{{ tabData.title }}</div>
                <div class="en">{{ tabData.t_desc }}</div>
              </div>
              <div class="cont">
                <div class="left">
                  <div class="top" v-html="tabData.content"></div>
                  <div class="bottom">
                    <div class="num">
                      <div class="tp">
                        <div class="l">
                          {{ tabData.reserve_1 }}
                        </div>
                        <div class="r">
                          <div style="color: #234CE2;">+</div>
                          <div>项</div>
                        </div>
                      </div>
                      <div class="btm">
                        {{ tabData.reserve_desc_1 }}
                      </div>
                    </div>
                    <div class="num">
                      <div class="tp">
                        <div class="l">
                          {{ tabData.reserve_2 }}
                        </div>
                        <div class="r">
                          <div style="color: #234CE2;">+</div>
                          <div>平</div>
                        </div>
                      </div>
                      <div class="btm">
                        {{ tabData.reserve_desc_2 }}
                      </div>
                    </div>
                    <div class="num">
                      <div class="tp">
                        <div class="l">
                          {{ tabData.reserve_3 }}
                        </div>
                        <div class="r">
                          <div style="color: #234CE2;">+</div>
                          <div>年</div>
                        </div>
                      </div>
                      <div class="btm">
                        {{ tabData.reserve_desc_3 }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="right">
                  <img :src="tabData.show_img" alt="">
                </div>
              </div>
            </div>
          </div>
          <!-- 企业文化 -->
          <div class="qywh" v-if="item.t_name === '企业文化'">
            <div style="width: 100%;height: 800px;">
              <div class="c_title">
                <div class="c_tl">{{ tabData.title }}</div>
                <div class="e_tl">{{ tabData.t_desc }}</div>
              </div>
              <div class="c_text" v-html="tabData.content"></div>
            </div>
          </div>
          <!-- 企业荣誉 -->
          <div class="qywh" v-if="item.t_name === '企业荣誉'">
            <div>
              <div class="c_title">
                <div class="c_tl"> {{ item.t_name }} </div>
                <div class="e_tl">{{ item.t_name_deputy }}</div>
              </div>
              <div>
                <div class="img">
                  <img :src="item.t_logo_deputy" alt="">
                </div>
                <div class="time" v-for="(i) in timeData" :key="i?.id">
                  <div class="xian">
                    <div class="d" v-for="it in 10" :key="it">

                    </div>
                  </div>
                  <div class="year">
                    <div class="yearTit">
                      {{ i?.t_desc }}
                    </div>
                    <div class="tot" v-html="i?.content">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 营销网络 -->
          <div class="qywh" v-if="item.t_name === '营销网络'">
            <div style="width: 100%;height: 900px;">
              <div class="c_title">
                <div class="c_tl"> {{ tabData.title }} </div>
                <div class="e_tl">{{ tabData.t_desc }}</div>
              </div>
              <div class="img">
                <img :src="tabData.show_img" alt="">
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      activeName: 'first',
      banner: '',
      pageData: [
      ],
      tabsList: [],
      tabData: {},
      timeData: {},
      width: {},
      move: false,
      down: false,
      X: '',
      Y: '',
      MouseX: '',
      pad: '',
      sliderValue: 0
    }
  },
  methods: {
    changeHandler(v) {
      console.log(document.querySelector('.time_boxs'))
      document.querySelector('.time_boxs').style.transform = `translate(-${v * (this.tabData.length + 50)}px)`
    },
    async handleClick(tab) {
      this.tabsList.forEach((v) => {
        if (v.t_name === tab.paneName) {

          this.banner = v.t_logo_main
          this.getTabData(v.id)
        }
      })
    },
    getData() { // 获取页面数据
      axios({
        url: this.base_url.base_url + '/index.php/index/index/navigation_list',
        method: 'get',
      }).then((res) => {
        this.pageData = res.data.data
        this.tabsList = this.pageData.bottom_list[0].child
        if (this.$route.query.id) { // 如果有id 判断
          this.tabsList.forEach(v => {
            if (v.id == this.$route.query.id) {
              this.activeName = v.t_name
              this.banner = v.t_logo_main
              this.getTabData(v.id)
            }
          })
        } else {
          this.activeName = this.tabsList[0].t_name
          this.banner = this.tabsList[0].t_logo_main
          this.getTabData()
        }
      }).catch((err) => {
        console.log(err);
      })
    },
    getTabData(cid = 7) { // 获取tab数据
      axios({
        url: this.base_url.base_url + `/index.php/index/index/news_list?nid=6&cid=${cid}`,
        method: 'get',
      }).then((res) => {
        this.tabData = res.data.data.news_data
        this.width = parseInt(this.tabData.length / 2) * 436 > 1980 ? '1980px' : parseInt(this.tabData.length / 2) * 436 + 'px'
        this.timeData = res.data.data.news_data
      }).catch((err) => {
        console.log(err);
      })
    },
  },

  created() {
    this.getData()
    document.body.scrollWidth > 1980 ? this.pad = 400 : this.pad = 100
  },
  mounted() {
  }
}
</script>

<style scoped lang="scss">
@media screen and (min-width: 1980px) {
  .c_box.left {
    left: 13% !important;
  }
}

@media screen and (max-width: 1980px) {
  .scroll_div {
    padding: 0 100px !important;
  }
}

.fzlc {
  margin: 80px auto;
  // width: 1920px;
  height: 1050px;

  .scroll_div {
    // width: 100%;
    // height: 2px;
    // border-top: 2px solid gray;
    // background-color: gray;
    padding: 0 400px;
    transform: translateY(-600px);
    transition: all 0.3s;
    position: absolute;

    .scroll {
      transform: translateY(-6px);
      height: 10px;
      width: 260px;
      background-color: #224be1;
      border-radius: 5px;
      cursor: pointer;
    }
  }

  .time_line {

    margin: 80px auto 0;
    width: 1920px;
    height: 1050px;
    overflow: hidden;

    .time_boxs {
      padding: 10px 0;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      width: 1920px;
      height: 1050px;

      .time_box {
        width: 336px;
        height: 360px;
        margin-left: 10px;
        padding: 50px;
        background: url('@/assets/img/bg/zheng.png') no-repeat center center / 100% 100%;




        .tm {
          text-align: left;
          font-size: 28px;
          margin-bottom: 10px;
        }

        .cot {
          max-height: 284px;
          overflow-y: auto;
          text-align: left;
          color: #666666;
          margin: 0;
        }

      }

      & .active {
        background: url('@/assets/img/bg/fan.png') no-repeat center center / 100% 100%;
      }

      :nth-child(2).time_box {
        margin-left: 180px;
      }

      :nth-child(2n).time_box {
        padding-top: 70px;
      }

      :nth-child(2n - 1).time_box {
        margin-left: -160px;
      }

      :nth-child(1).time_box {
        margin-left: 10px;
      }
    }
  }
}


.yfsl {
  width: 1430px;
  margin: 30px auto 80px;

  .tt {
    margin-bottom: 44px;
    text-align: center;

    .cn {
      font-size: 30px;
      color: #333;
    }

    .en {
      font-size: 14px;
      color: #949594;
    }
  }

  .cont {
    width: 1430px;
    height: 671px;
    display: flex;

    .left {
      margin-right: 75px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      ::v-deep .top {
        font-size: 24px;
        line-height: 2em;
        margin-bottom: 20px;

        p {
          font-size: 36px;
        //   line-height: 3em;
          margin-bottom: 20px;
          img{
            object-fit: contain;
        }
        }
      }

      .bottom {
        display: flex;

        .num {
          height: 80px;
          border-right: 1px solid #D8D8D8;
          flex: 1;

          .tp {
            display: flex;
            justify-content: center;

            .l {
              color: #234CE2;
              font-size: 60px;
            }

            .r {
              display: flex;
              flex-direction: column;
              justify-content: space-evenly;
            }
          }

          .btm {
            text-align: center;
          }
        }
      }
    }

    .right {
      width: 556px;
      height: 671px;

      img {
        width: 556px;
        height: 671px;
      }
    }
  }
}

.qywh {
  margin-bottom: 140px;

  .c_title {
    font-size: 30px;
    color: #333;
    text-align: center;
    margin-bottom: 60px;


    ::before {
      border-color: transparent;
    }
  }

  .c_text {
    margin: 0 auto;
  }

  .img {
    width: 1149px;
    margin: 0 auto 80px;

    img {
      width: 1149px;
      // height: 786px;
    }
  }

  .time {
    width: 1149px;
    margin: 0 auto;

    .xian {
      width: 10px;
      margin-left: 50px;

      .d {
        width: 5px;
        height: 5px;
        border-radius: 5px;
        background-color: #666;
        margin-bottom: 10px;
      }
    }

    .year {
      margin: 30px 0;
      position: relative;

      .yearTit {
        color: #0060DF;
        font-size: 28px;
      }

      .tot {
        position: absolute;
        top: 50%;
        left: 10%;
        transform: translate(0%, -50%);
        font-size: 24px;
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 400;
        color: #666666;
        line-height: 30px;
      }
    }
  }
}

.a_pic {
  width: 100%;
}

.a_pic img {
  width: 100%;
}

.el-tabs__header {
  margin-top: 20px !important;
}

.el-tabs__item {
  font-size: 18px !important;
  font-family: Source Han Sans CN !important;
  font-weight: 500 !important;
  color: #333333 !important;
  margin-bottom: 12px !important;
  /* padding: 0 2.5% !important; */
  width: 187px;
  /* line-height: 60px  !important; */

}

.el-tabs__item:hover {
  color: #234CE2 !important;
}

.el-tabs__item.is-active {
  color: #234CE2 !important;
}

.el-tabs__active-bar {
  background-color: #234CE2 !important;
}

.el-tabs__nav-wrap::after {
  height: 1px !important;
  background-color: #3E3A39 !important;
}

.el-tabs--top .el-tabs__item.is-top:nth-child(2) {
  padding-left: 14% !important;
}

::v-deep .el-tabs__item.is-top {
  height: 60px !important;
  line-height: 60px;
}

::v-deep .el-tabs__nav-scroll {
  // padding: 0 400px !important;
  width: 1323px;
  margin: 0 auto;
}

.el-tabs--bottom .el-tabs__item.is-bottom:last-child,
.el-tabs--bottom .el-tabs__item.is-top:last-child,
.el-tabs--top .el-tabs__item.is-bottom:last-child,
.el-tabs--top .el-tabs__item.is-top:last-child {
  padding-right: 14% !important;
}

.tabs .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
  padding-left: 22% !important;
}

.tabs .el-tabs--bottom .el-tabs__item.is-bottom:last-child,
.el-tabs--bottom .el-tabs__item.is-top:last-child,
.el-tabs--top .el-tabs__item.is-bottom:last-child,
.el-tabs--top .el-tabs__item.is-top:last-child {
  padding-right: 22% !important;
}



.el-tabs__content {
  margin-bottom: 50px;
}


/* 公司简介 */
.c_introduction {
  width: 100%;
  height: 970px;
  position: relative;

  .c_tl:before {
    content: "";
    width: 3px;
    height: 31px;
    background: #234CE2;
    position: absolute;
    top: 10px;
    left: -10px;
  }

  .c_pic {
    width: 100%;
    height: 100%;
    margin: 0 auto;
  }

  .c_box {
    width: 70%;
    // min-width: 1200px;
    height: 580px;
    margin: 0px auto;
    margin-bottom: 100px;
    position: absolute;
    left: 25%;
    top: 20%;

    .c_word {
      width: 580px;
      height: 100%;

    }
  }
}





.c_tl {
  font-size: 34px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  position: relative;
  margin-left: 10px;
}

.e_tl {
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #949594;
  line-height: 30px;
  margin-left: 5px;
}

.c_text {
  width: 585px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #949594;
  line-height: 30px;
  margin-top: 30px;
  margin-bottom: 30px;
}

.shuzi {
  display: flex;
  justify-content: space-between;
}

.big_digit {
  width: 49px;
  height: 43px;
  font-size: 55px;
  font-family: AR DIN Sans Flat Bold;
  font-weight: 400;
  color: #234CE2;

}

.digit {
  display: flex;
  width: 160px;
  height: 85px;
  justify-content: center;
  border-right: 2px solid #dae6ef;
}

:last-child {
  border: 0;
}

.digit .top {
  display: flex;
  margin-left: 10px;
  justify-content: center;
}

.digit .bottom {
  width: 110px;
  height: 16px;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  margin-top: 10px;
  text-align: center;
}

.digit .top .right {
  margin-left: 6px;
  // margin-top: 10px;
}

.digit .top .bottom1 {
  margin-top: 20px;
  width: 29px;
  height: 13px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
}

.digit .top .top1 {
  width: 12px;
  height: 14px;
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #234CE2;
  margin-top: -3px;
}

.huise {
  width: 500px;
  height: 550px;
  background: #3E3A39;
  opacity: 0.1;
  position: absolute;
  right: 0;
  top: 30px;
}

.c_pic {
  position: relative;

}

.c_pic img {
  position: absolute;
}

/* 公司简介 */
/* 发展历程 */
.th_title {
  width: 100%;
  height: 100px;
  text-align: center;
  margin-top: 80px;
  margin-bottom: 90px;
}

.th_word {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.th_pic {
  width: 100%;
  height: 400px;
  position: relative;
  transform: scale(0.7);
}

.lit_a_1 {
  width: 72px;
  height: 29px;
  font-size: 36px;
  font-family: AR Dori Sans;
  font-weight: bold;
  color: #333333;
  position: absolute;
  top: 135px;
  left: 125px;
}

.lit_a_2 {
  width: 72px;
  height: 29px;
  font-size: 36px;
  font-family: AR Dori Sans;
  font-weight: bold;
  color: #0060DF;
  position: absolute;
  top: 135px;
  left: 500px;
}

.lit_a_3 {
  width: 73px;
  height: 28px;
  font-size: 36px;
  font-family: AR Dori Sans;
  font-weight: bold;
  color: #333333;
  position: absolute;
  top: 135px;
  left: 900px;
}

.th_pic_word {
  width: 143%;
  height: 200px;
  border-top: 3px solid #3E3A39;
  position: absolute;
  bottom: 0;
  left: 0;
  transform: translateX(-15%);
}

.his_left {
  position: absolute;
  top: 75px;
  left: 300px;
  transform: scaleY(1.4);
}

.his_right {
  position: absolute;
  top: 75px;
  right: 250px;
  transform: scaleY(1.4);
}

.lit_b_1 {
  width: 16px;
  height: 20px;
  background: #234CE2;
  border-radius: 50%;
  position: absolute;
  top: -10px;
  left: 22%;
}

.lit_w_1 {
  position: absolute;
  top: 70px;
  left: 22%;
}

.lit_b_2 {
  width: 18px;
  height: 22px;
  background: #FFFFFF;
  border: 2px solid #234CE2;
  border-radius: 50%;
  position: absolute;
  top: -14px;
  left: 44%;
}

.lit_w_2 {
  position: absolute;
  top: 70px;
  left: 44%;
}

.lit_b_3 {
  width: 16px;
  height: 20px;
  background: #234CE2;
  border-radius: 50%;
  position: absolute;
  top: -11px;
  left: 67%;
}

.lit_w_3 {
  position: absolute;
  top: 70px;
  left: 67%;
}

.th_pic_word p {
  font-size: 10px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #3E3A39;
  line-height: 30px;
  transform: scaleY(1.5);
}

.th_pic1 {
  position: absolute;
  top: 40px;
  left: 220px;
}

.th_pic2 {
  position: absolute;
  top: 40px;
  left: 600px;
}

.th_pic3 {
  position: absolute;
  top: 0px;
  left: 900px;
}

.th_pic1 img {
  width: 195px;
  height: 120px;
}

.th_pic2 img {
  width: 178px;
  height: 121px;
}

.th_pic3 img {
  width: 450px;
  height: 120px;
}


/* 发展历程 */
/* 企业文化 */
.jieshao_img {
  position: absolute;
  top: 0;
  left: 0;
}

.jieshao_img img {
  /* width: 580px; */
  height: 500px;
}

.jieshao {
  position: absolute;
  top: 0;
  left: 54%;
}

.jieshao img {
  position: absolute;
  top: 40px;
  width: 518px;
  height: 310px;
}

/* 企业文化 */

/* 企业荣耀 */

.el-carousel__indicators--outside button {
  width: 7px !important;
  height: 7px !important;
  border-radius: 7px !important;
  background: #234CE2 !important;

}

.is-active .el-carousel__button {
  width: 10px !important;
  height: 10px !important;
  border-radius: 10px;
  background: #234CE2 !important;

}

.el-carousel {
  position: relative;
  width: 70% !important;
  margin: 0 auto !important;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}

/* 企业荣耀 */
/* 图片的显示与隐藏 */
.disnon {
  display: none;
}

.disb {
  display: block;
}

/*  */
.tanY {
  transform: scaleY(0.7);
}

.tan {
  transform: scale(0.7);
}
</style>